import {
    CalendarMonthOutlined,
    PersonOutlineOutlined,
} from "@mui/icons-material";
import dayjs from "dayjs";
import { DriverAlertType } from "../types/types";
import NotificationCard from "./NotificationCard";

type DriverAlertCardProps = {
    alert: DriverAlertType;
};

const DriverAlertCard = ({ alert }: DriverAlertCardProps) => (
    <NotificationCard
        category="CNH"
        severity={alert.severity === "CRITICAL" ? "CRÍTICO" : "ATENÇÃO"}
        severityColor={alert.severity === "CRITICAL" ? "error" : "warning"}
        title={alert.title}
        subject={alert.driverName}
        subjectIcon={<PersonOutlineOutlined fontSize="small" color="primary" />}
        message={alert.message}
        details={[{
            key: "due-date",
            icon: <CalendarMonthOutlined fontSize="small" color="action" />,
            text: `Validade: ${dayjs(alert.dueDate).format("DD/MM/YYYY")}`,
        }]}
    />
);

export default DriverAlertCard;
